<div *ngIf="inventar">
  <xng-breadcrumb></xng-breadcrumb>
</div>
<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Loading...'"></div>
</div>
<div class="container pt-4" *ngIf="!isLoading">
  <h5 class="orange" translate>products.products</h5>
  <p *ngIf="inventar" translate [translateParams]="{inventarName: inventar?.name}">products.inventarName</p>
</div>
<div *ngIf="products" class="container">
  <div *ngIf="isAllProducts" class="row">
    <app-search-input class="col-6" style="max-width: 300px; display: block;" [placeholder]="'products.searchByTitle' | translate"
      [searchControl]="myControl"></app-search-input>
    <app-search-input class="col-4" style="max-width: 300px;" [placeholder]="'products.searchByUserName' | translate"
      [searchControl]="searchControlUsername"></app-search-input>
    <app-custom-select style="max-width: 300px; display: block;" [options]="companies"
      (selectionChange)="onSelectionChange($event)"></app-custom-select>
  </div>
  <div *ngIf="!isAllProducts">
    <div class="col-6 d-flex flex-wrap justify-content-between">
      <div class="search-container mx-0 col-6">
        <div class="search-text d-flex">
          <input type="text" [formControl]='myControl' class="search" [placeholder]="'products.searchByTitle' | translate">
        </div>
        <span class="search-icon"><i class="fa fa-search"></i></span>
      </div>
      <div *ngIf="!isAllProducts" class="col-6">
        <select *ngIf="currentUser.role.name !== 'worker'" class="select" name="user" (change)="searchProduct()"
          [(ngModel)]="selectedUserId">
          <option disabled selected value="undefined" translate>workers.selectWorker</option>
          <option [value]="undefined" translate>workers.allWorkers</option>
          <option *ngFor="let user of userList" [value]="user.id">{{user.name}}</option>
        </select>
      </div>
      <p class="mt-3" translate>products.productStatus</p>
      <div class="col-12 d-flex" style="margin-right: 15px;">
        <label class="status" *ngFor="let item of statusOptions; let i = index">
          <input class="status-input" value={{item.name}} [checked]="item.isChecked" type="checkbox"
            (change)="changeStatus(i, $event)">
          <span class="status-text">{{item.name}}</span>
        </label>
      </div>

      <!-- date -->
      <div class="col-12 date-container my-4">
        <form class="row" style="width: 100%;">
          <div id="datepicker" class="form-group hide-date">
            <div class="input-group">
              <input name="datepicker" style="display: none;" class="form-control" ngbDatepicker
                [footerTemplate]="footerTemplate" #datepicker="ngbDatepicker" [autoClose]="'outside'"
                (dateSelect)="onDateSelection($event, datepicker)" [displayMonths]="2" [dayTemplate]="t"
                outsideDays="hidden" [startDate]="fromDate!">
              <ng-template #t let-date="date" let-focused="focused">
                <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                  [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                  (mouseleave)="hoveredDate = null">
                  {{ date.day }}
                </span>
              </ng-template>
              <ng-template #footerTemplate>
                <hr class="my-0">
                <button class="btn btn-primary btn-sm m-2 float-left" (click)="lastWeek(); datepicker.close()"
                  translate>global.lastWeek</button>
                <button class="btn btn-secondary btn-sm m-2 float-right" (click)="lastMonth(); datepicker.close()"
                  translate>global.lastMonth</button>
              </ng-template>
            </div>
          </div>
          <div class="form-group col-6">
            <p style="font-size: .9rem;" translate>global.from</p>
            <div class="input-group">
              <input #dpFromDate id="fromDate" class="form-control date-input" placeholder="yyyy-mm-dd"
                name="dpFromDate" [value]="formatter.format(fromDate)"
                (input)="fromDate = validateInput(fromDate, dpFromDate.value)">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary calendar" style="border: none;" (click)="datepicker.toggle()"
                  type="button"></button>
              </div>
            </div>
          </div>
          <div class="form-group col-6">
            <p style="font-size: .9rem;" translate>global.to</p>
            <div class="input-group">
              <input #dpToDate id="toDate" class="form-control date-input" placeholder="yyyy-mm-dd" name="dpToDate"
                [value]="formatter.format(toDate)" (input)="toDate = validateInput(toDate, dpToDate.value)">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary calendar" style="border: none;" (click)="datepicker.toggle()"
                  type="button"></button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- /date -->
    </div>
  </div>

  <div *ngIf="!products.results.length" class="container pt-4" translate>products.noProducts</div>

  <ng-container *ngIf="products.results.length">
    <p class="number-vehicles">{{ lower }}-{{ upper }} <span style="font-weight: 300;" translate>products.productOf</span>
      {{ products.totalCount }} <span style="font-weight: 300; text-transform: lowercase;" translate>products.products</span></p>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12" *ngFor="let product of products.results">
        <app-product-item [product]="product" (seeProduct)="seeProduct($event)" (deleteProduct)="deleteProduct($event)"
          (statusProduct)="openStatusProduct($event)">
        </app-product-item>
      </div>
    </div>
    <ngb-pagination [collectionSize]="products.totalCount" [(pageSize)]="perPage" [(page)]="page" [maxSize]="5"
      [rotate]="true" (pageChange)="jumpToPage($event)"></ngb-pagination>
  </ng-container>

</div>
<!-- <div *ngIf="products && !products.results.length" class="container pt-4" translate>products.noProducts</div> -->

<app-modal (close)="toggleProduct = !toggleProduct" *ngIf="toggleProduct">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate><span translate>products.product</span>:
        {{selectedProduct.title}}</h4>
    </div>
    <div class="modal-body">
      <div *ngIf="selectedProduct.status === 'cancelled' && selectedProduct.reason" class="reason-box">
        <p translate>products.cancelReasonInfo</p>
        <p>{{selectedProduct.reason}}</p>
      </div>
      <div *ngIf="selectedProduct.status === 'active' && selectedProduct.reason" class="reason-box green">
        <p translate>products.openReasonInfo</p>
        <p>{{selectedProduct.reason}}</p>
      </div>
      <img class="w-100 mb-2" *ngIf="selectedProduct.previewImage" [src]="selectedProduct.previewImage.path" alt="">
      <form #productForm="ngForm">
        <div class="form-group mb-2">
          <label translate>global.title</label>
          <input type="text"
            [readonly]="['worker'].includes(currentUser.role.name) || ['finished', 'cancelled'].includes(selectedProduct.status)"
            name="title" [ngModel]="selectedProduct.title" class="form-control">
        </div>
        <div class="form-group mb-2">
          <label translate>global.description</label>
          <input type="text"
            [readonly]="['worker'].includes(currentUser.role.name) || ['finished', 'cancelled'].includes(selectedProduct.status)"
            name="description" [ngModel]="selectedProduct.description" class="form-control">
        </div>
        <div *ngIf="selectedProduct.kilometers" class="form-group mb-2">
          <label translate>global.mileage</label>
          <input type="text"
            [readonly]="['worker'].includes(currentUser.role.name) || ['finished', 'cancelled'].includes(selectedProduct.status)"
            name="kilometers" required [ngModel]="selectedProduct.kilometers" class="form-control">
        </div>
        <div
          *ngIf="!['worker'].includes(currentUser.role.name) && !['finished', 'cancelled'].includes(selectedProduct.status)"
          class="w-100">
          <button class="custom_button edit_button" (click)="editProduct(productForm)">Edit Product</button>
        </div>
      </form>
      <!-- <div class="form-group">
        <input type="text" readonly [ngModel]="selectedProduct.title" class="form-control">
      </div> -->
      <p class="mt-2" translate>products.scannedImage</p>
      <img class="w-100" *ngIf="selectedProduct.scannedImage" [src]="selectedProduct.scannedImage.path" alt="">
      <div *ngIf="!selectedProduct.scannedImage">
        <div *ngFor="let img of selectedProduct.images">
          <div *ngIf="img.type === 'keyboard'">
            <img class="w-100" [src]="img.path" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</app-modal>

<app-modal (close)="toggleStatusProduct = !toggleStatusProduct" *ngIf="toggleStatusProduct">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-header">
      <h4 *ngIf="openStatus" class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate>products.openProduct
      </h4>
      <h4 *ngIf="!openStatus" class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate>products.cancelProduct</h4>
    </div>
    <div class="modal-body">
      <form #productForm="ngForm">
        <!-- Reason -->
        <div class="form-group mb-2">
          <label translate>filials.filial.enterReasonInfo</label>
          <textarea type="text" #reason="ngModel" autocomplete="off" required [ngModel] class="form-control"
            [class.is-invalid]="reason.invalid && reason.touched" name="reason"></textarea>
        </div>
        <button *ngIf="!openStatus" class="custom_button" (click)="changeStatusProduct('cancelled', productForm)"
          translate>products.cancelProduct</button>
        <button *ngIf="openStatus" class="custom_button" (click)="changeStatusProduct('active', productForm)"
         translate>products.openProduct</button>
        <button class="custom_button" (click)="toggleStatusProduct = false;" translate>global.cancel</button>
      </form>
    </div>
  </div>
</app-modal>